import { ShoppingCartSortField } from "@saleor/createOrderExport/urls";
import { ScgExportCartOrderField } from "@saleor/graphql";
import { createGetSortQueryVariables } from "@saleor/utils/sort";

export function getSortQueryShoppingCartField(
  sort: ShoppingCartSortField
): ScgExportCartOrderField {
  switch (sort) {
    case ShoppingCartSortField.solde_to:
      return ScgExportCartOrderField.SOLD_TO;
    default:
      return undefined;
  }
}

export const getSortQueryShoppingCartVariables = createGetSortQueryVariables(
  getSortQueryShoppingCartField
);
